import type { FunctionComponent } from 'react';
import classNames from 'classnames';
import { ICountrySelect } from '../../../../interfaces';
import FieldError from '../FieldError/FieldError';
import {
  CSRF_CA_OPTION,
  CSRF_CONTAINER,
  CSRF_CONTENT,
  CSRF_GB_OPTION,
  CSRF_SELECT,
  CSRF_US_OPTION,
} from './countrySelectTestIds';
import * as styles from './CountrySelect.module.css';

const CountrySelect: FunctionComponent<ICountrySelect> = ({
  fieldState,
  billingCountry,
  containerClassName,
  onFocus,
}) => {
  const selectStyles = fieldState.hasError
    ? `${styles.csrfSelect} ${styles.csrfInvalid}`
    : styles.csrfSelect;

  return (
    <label
      data-testid={CSRF_CONTAINER}
      htmlFor="country"
      className={classNames(styles.csrfContainer, containerClassName)}
    >
      Country
      <div data-testid={CSRF_CONTENT} className={styles.csrfChevron}>
        <select
          data-testid={CSRF_SELECT}
          id="country"
          name="country"
          data-recurly="country"
          onChange={fieldState.changeHandler}
          onBlur={fieldState.blurHandler}
          value={billingCountry || fieldState.value}
          className={selectStyles}
          onFocus={onFocus}
        >
          <option data-testid={CSRF_CA_OPTION} value="CA">
            Canada
          </option>
          <option data-testid={CSRF_GB_OPTION} value="GB">
            United Kingdom
          </option>
          <option data-testid={CSRF_US_OPTION} value="US">
            United States
          </option>
        </select>
      </div>
      {fieldState.hasError && <FieldError errorMsg={fieldState.errorMsg} />}
    </label>
  );
};

export default CountrySelect;
